module.exports = __webpack_public_path__ + "img/plus_btn.a693d647.png";